import { Component, ViewChild } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, App, NavController, NavParams, Slides } from 'ionic-angular';
import * as $ from 'jquery';
import { ConfigProvider } from '../../../providers/config/config';
import { EventAutoCompleteModel, EventProvider, Pager } from '../../../providers/event/event';
import { LoaderProvider } from '../../../providers/loader/loader';
import { ResultCreateModel, ResultProvider } from '../../../providers/result/result';
import { UserProvider } from '../../../providers/user/user';
import { SinleValueModel, ValueProvider } from '../../../providers/value/value';
import { EventCreateTabsPage } from '../../event/create/event-create-tabs/event-create-tabs';

@Component({
  selector: 'page-result-create-pager',
  templateUrl: 'result-create-pager.html'
})
export class ResultCreatePagerPage {
  @ViewChild('slider')
  slider: Slides;
  @ViewChild('uploadButton')
  uploadButton: any;

  model: any = {};

  autoCompleteValue: string;
  autoCompleteTimer: any;
  autoCompleteList: EventAutoCompleteModel[];
  autoCompleteSelected: any = {};

  eventDates: SinleValueModel[] = [];
  eventDistances: SinleValueModel[] = [];
  eventTypes: SinleValueModel[] = [];

  editDate?: string = null;
  distPart1?: { data: number } = null;
  distPart2?: { data: number } = null;
  distPart3?: { data: number } = null;

  constructor(
    public navCtrl: NavController,
    public app: App,
    public translate: TranslateService,
    public navParams: NavParams,
    private eventService: EventProvider,
    private valueService: ValueProvider,
    private resultService: ResultProvider,
    private userService: UserProvider,
    private camera: Camera,
    private loadingCtrl: LoaderProvider,
    private alertCtrl: AlertController,
    private config: ConfigProvider
  ) { }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResultCreatePagerPage');
    this.slider.lockSwipeToNext(true);
  }

  next() {
    this.slider.lockSwipeToNext(false);
    this.slider.slideNext();
    if (this.slider.getActiveIndex() === 2) {
      this.createFileInput();
    }

    this.slider.lockSwipeToNext(true);
  }

  showNewEvent() {
    this.app.getRootNav().push(EventCreateTabsPage);
  }
  fileInputClick() {
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      correctOrientation: true
    };
    this.camera
      .getPicture(options)
      .then(photo => {
        this.model.img = 'data:image/jpeg;base64,' + photo;
      })
      .catch();
  }

  async createFileInput() {
    if (!(await this.config.config).platform.browser) return;
    if (document.querySelector('.cordova-camera-select')) return;
    try {
      const options: CameraOptions = {
        quality: 100,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
        sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
        correctOrientation: true
      };
      this.camera.getPicture(options).then(photo => {
        this.model.img = 'data:image/jpeg;base64,' + photo;
        this.createFileInput();
      });
      var input = document.querySelector('.cordova-camera-select');
      document.body.removeChild(input);
      this.uploadButton.getNativeElement().appendChild(input);
    } catch {
      this.model.img =
        'data:image/png;base64,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';
    }
  }

  prev() {
    this.slider.slidePrev();
  }

  autocompleteKeyUp(event) {
    this.autoCompleteSelected = {};
    if (this.autoCompleteTimer) {
      clearInterval(this.autoCompleteTimer);
    }
    this.autoCompleteTimer = setTimeout(() => {
      this.eventService.getAutocompleteResults(event.target.value).then(values => {
        this.autoCompleteList = values;
      });
    }, 400);
  }
  autoCompleteSelect(selected: EventAutoCompleteModel) {
    this.autoCompleteSelected = selected;
    this.autoCompleteValue = selected.eventName;
    this.autoCompleteList = [];
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present().then(() => {
      Promise.all([
        this.valueService.getEventDistancesByName(this.autoCompleteValue),
        this.valueService.getEventYearsByName(this.autoCompleteValue),
        this.valueService.getEventTypesByName(this.autoCompleteValue)
      ]).then(result => {
        this.setUpField('eventDistances', 'dist', result[0]);
        this.setUpField('eventDates', 'year', result[1]);
        this.setUpField('eventTypes', 'type', result[2]);
        loader.dismiss();
      });
    });
  }

  setUpField(selectfield: string, selectedField: string, values: SinleValueModel[]) {
    this[selectfield] = values;
    if (!this[selectfield].find(x => x.value === this.model.dist)) {
      if (this[selectfield].length > 0) {
        this.model[selectedField] = this[selectfield][0].value;
      } else {
        this.model[selectedField] = null;
      }
    }
  }

  async selectPhoto() {
    if ((await this.config.config).platform.browser) {
      $('.cordova-camera-select').click();
    } else {
      this.fileInputClick();
    }
  }

  changeDateEditable() {
    if (this.editDate) {
      this.editDate = null;
    } else {
      if (this.model.year) {
        let splitDate = (this.model.year as string).split('.').map(x => parseInt(x));
        this.editDate = new Date(splitDate[2], splitDate[1] - 1, splitDate[0] + 1).toISOString();
      } else {
        this.editDate = new Date().toISOString();
      }
    }
  }
  dateChange(event: string, timeField: any) {
    if (!this.eventDates.find(x => x.value === timeField._text)) {
      this.eventDates.push({ value: timeField._text });
    }
    this.model.year = timeField._text;
  }
  changeDistaceEditable() {
    if (this.distPart1 === null) {
      var splitDist = (this.model.dist as string)
        .replace('km', '')
        .replace(',', '.')
        .replace(',', '.')
        .replace(',', '.')
        .split('-');
      if (splitDist[0]) {
        this.distPart1 = { data: parseFloat(splitDist[0]) };
      }
      if (splitDist[1]) {
        this.distPart2 = { data: parseFloat(splitDist[1]) };
      }
      if (splitDist[2]) {
        this.distPart3 = { data: parseFloat(splitDist[2]) };
      }
    } else {
      var con = this.distPart1.data + '';

      if (this.distPart2) {
        con += '-' + this.distPart2.data;
      }
      if (this.distPart3) {
        con += '-' + this.distPart3.data;
      }
      con += 'km';
      con = con
        .replace('.', ',')
        .replace('.', ',')
        .replace('.', ',');
      if (!this.eventDistances.find(x => x.value === con)) {
        this.eventDistances.push({ value: con });
      }
      this.model.dist = con;

      this.distPart1 = null;
      this.distPart2 = null;
      this.distPart3 = null;
    }
  }

  eventGrading: SinleValueModel[];
  eventVintagesFrom: SinleValueModel[];
  eventVintagesTo: SinleValueModel[];

  selectedGrading?: string;
  selectedVintageFrom?: string;
  selectedVintageTo?: string;

  changeGradingEditable() {
    if (this.selectedGrading) {
      let loader = this.loadingCtrl.create({
        content: this.translate.instant('GLOBAL_LOADING')
      });
      loader.present();
      this.valueService
        .getEventGradingTextCheck(this.selectedGrading, this.selectedVintageFrom, this.selectedVintageTo)
        .then(value => {
          if (!this.eventTypes.find(x => x.value === value.value)) {
            this.eventTypes.push(value);
          }
          this.model.type = value.value;
          loader.dismiss();
          this.selectedGrading = null;
          this.selectedVintageFrom = null;
          this.selectedVintageTo = null;
        })
        .catch(err => {
          loader.dismiss();
        });
    } else {
      this.getGrading();
    }
  }

  getGrading() {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();
    this.valueService.getEventGrading().then(values => {
      this.eventGrading = values;
      if (this.eventGrading.length > 0) {
        this.selectedGrading = this.eventGrading[0].value;
        this.getVintagesFrom(this.selectedGrading);
        this.getVintagesTo(this.selectedGrading);
      }
      loader.dismiss();
    });
  }
  getVintagesFrom(grad: string) {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();
    this.valueService.getEventVintagesFrom(grad).then(values => {
      this.eventVintagesFrom = values;
      if (values.length > 0) this.selectedVintageFrom = this.eventVintagesFrom[0].value;

      loader.dismiss();
    });
  }
  getVintagesTo(grad: string) {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();
    this.valueService.getEventVintagesTo(grad).then(values => {
      this.eventVintagesTo = values;
      if (values.length > 0) this.selectedVintageTo = this.eventVintagesTo[0].value;

      loader.dismiss();
    });
  }

  displayNextButton() {
    if (this.slider.getActiveIndex() === 0) {
      return this.autoCompleteSelected.cid ? true : false;
    } else if (this.slider.getActiveIndex() === 1) {
      return this.model.type && this.model.year && this.model.dist;
    } else if (this.slider.getActiveIndex() === 2) {
      return this.model.img && this.model.time && this.model.place;
    }
  }

  displaySaveButton() {
    if (this.slider.getActiveIndex() === 3) {
      return this.model.type && this.model.year && this.model.dist && this.model.img && this.model.time && this.model.place;
    }
  }

  displaySearch() {
    if (this.slider.getActiveIndex() === 0) {
      return true;
    }
  }

  save() {
    let sEvent = this.autoCompleteSelected as EventAutoCompleteModel;
    let value: ResultCreateModel = {
      area: sEvent.area,
      cid: sEvent.cid,
      city: sEvent.city,
      country: sEvent.country,
      ena: sEvent.eventName,
      place: this.model.place,
      zip: sEvent.zip,
      eventDate: this.model.year,
      picName: this.model.img,
      resulttime: this.model.time,
      strecke: this.model.dist,
      type: this.model.type
    };
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();
    this.resultService.createResult(value).then(is => {
      if (is) {
        this.alertCtrl.create({ message: 'Result has been created', buttons: ['Ok'] }).present();
      } else {
        this.alertCtrl.create({ message: 'Error: cannot create result' }).present();
      }
      loader.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// /src/pages/results/result-create-pager/result-create-pager.ts